module.exports = __webpack_public_path__ + "img/H-63-ST-1500-BE.ad387d89.png";